<template>
    <rkm-area
        type="fieldset"
        title="Profissionais"
        show-legend
    >

        <rkm-row v-if="data.form">
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                    :searchFields="fields.autocomplete.usuario"
                    :validations="validations.usuario"
                    text-field="cidadaoNome"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="data.model.profissional.usuario"
                    uppercase
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="data.model.profissional.unidadeId"
                    :validations="validations.unidade"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.profissional.usuario && data.model.profissional.usuario.id ? false : true"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.profissional.infraestruturaId"
                    :validations="validations.infraestrutura"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="data.model.profissional.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    textField="descricao"
                    v-model="data.model.profissional.equipeId"
                    :validations="validations.equipe"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.profissional.infraestruturaId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="CBO"
                    :options="ocupacoes"
                    textField="codigoNome"
                    v-model="data.model.profissional.ocupacaoId"
                    :validations="validations.ocupacao"
                    valueField="id"
                    show-default-option
                    :disabled="data.model.profissional.infraestruturaId == null"
                />
            </rkm-col>

            <rkm-col cols="2"
                :hidden="hideProfissionais"
            >
                <rkm-button
                    class="mt-4"
                    @click="$refs.ModalProfissional.open(data.model.profissional, data.model.profissionais)"
                    color="primary"
                    small
                    :disabled="data.model.profissional.usuario && data.model.profissional.usuario.id ? false : true"
                >
                    Outros profissionais
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <ModalProfissional
            :data="{ form, model }"
            ref="ModalProfissional"
            @profissionais="profissionais"
        />
    </rkm-area>
</template>

<script>

//Modal
import ModalProfissional from './Modal'

// Vuex.
import { mapActions } from 'vuex'

// Filters
import formats from '@/filters/formats'

// Enums.
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import pse from '@/enums/atencao-basica/atividade-coletiva/pse'

// Mixins
import { repository, object } from '@/mixins'

export default {
    components: {
        ModalProfissional
    },
    computed: {
        hideProfissionais() {

            if (this.data.model.cadastro.pseId == this.enums.pse.SAUDE || this.data.model.cadastro.pseId == null) {
                return false
            } else {
                return true
            }

        },
        validations() {
            return {
                usuario: { required: true },
                unidade: { required: true },
                infraestrutura: { required: true },
                equipe: { required: true },
                ocupacao: { required: true },
                data: { required: true },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.ATIVIDADE_COLETIVA
                },
            }
        },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atividadeColetiva: this.getConectaSusRepository('atencaoBasica.atividadeColetiva')
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        profissionais(profissionais) {
            this.$emit('profissionais', profissionais)
        },
        getUnidades() {

            this.setLoading()

            this.repositories.atividadeColetiva.getUnidades({usuario_id: this.data.model.profissional.usuario.id})
                .then(({ data }) => {

                    this.unidades = data

                    if (data.length === 1){

                        this.data.model.profissional.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {

            this.setLoading()

            this.repositories.atividadeColetiva.getEquipes({
                usuario_id: this.data.model.profissional.usuario.id,
                infraestrutura_id: this.data.model.profissional.infraestruturaId
            })
                .then(({ data }) => {

                    this.equipes = data

                    if (data.length === 1){

                        this.data.model.profissional.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {

            this.setLoading()

            this.repositories.atividadeColetiva.getOcupacoes({
                usuario_id: this.data.model.profissional.usuario.id,
                infraestrutura_id: this.data.model.profissional.infraestruturaId
            })
                .then(({ data }) => {

                    this.ocupacoes = data

                    if (data.length === 1){

                        this.data.model.profissional.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.setLoading()

            this.repositories.atividadeColetiva.getInfraestruturas({
                usuario_id: this.data.model.profissional.usuario.id,
                unidade_id: this.data.model.profissional.unidadeId
            })
                .then(({ data }) => {

                    this.infraestruturas = data

                    if (data.length === 1) {

                        this.data.model.profissional.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setCadastro(field) {

            if (field === 'usuario') {

                this.data.model.profissional.unidadeId = null
                this.data.model.profissional.infraestruturaId = null
                this.data.model.profissional.equipeId = null
                this.data.model.profissional.ocupacaoId = null
            } else if (field === 'unidade'){

                this.data.model.profissional.infraestruturaId = null
                this.data.model.profissional.equipeId = null
                this.data.model.profissional.ocupacaoId = null
            } else {

                this.data.model.profissional.equipeId = null
                this.data.model.profissional.ocupacaoId = null
            }
        }
    },
    data() {
        return {
            enums: {
                permissao,
                pse,
            },
            unidades: [],
            infraestruturas: [],
            equipes: [],
            ocupacoes: [],
            model: {
                profissionais: []
            },
            form: null,
        }
    },
    mixins: [ repository, object, formats, ],
    props: {
        data: { type: Object, required: false },
        id: { type: Number }
    },
    mounted () {
        this.$nextTick(function () {

            if (this.data.model.profissional.usuario && this.data.model.profissional.usuario.id) {

                this.getUnidades()

                if (this.data.model.profissional.unidadeId) {

                    this.getInfraestruturas()
                    this.getEquipes()
                    this.getOcupacoes()
                }
            }
        })
    },
    watch: {
        'data.model.profissional.usuario': function (usuario) {

            if (usuario && usuario.id) {

                this.getUnidades()
            }

            this.setCadastro('usuario')
        },
        'data.model.profissional.unidadeId': function (unidadeId) {

            if (unidadeId) {

                this.getInfraestruturas()
            }

            this.setCadastro('unidade')
        },
        'data.model.profissional.infraestruturaId': function (infraestruturaId) {

            if (infraestruturaId) {

                this.getEquipes()
                this.getOcupacoes()
            }

            this.setCadastro('infraestrutura')
        },
    }
}
</script>